import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BASE = "https://mtcrenovation.ca";

export function useSEO(title, description) {
  const { pathname } = useLocation();
  useEffect(() => {
    document.title = title;
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute("content", description);
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute("href", BASE + pathname);
  }, [title, description, pathname]);
}
